import { createContext, useCallback, useContext, useEffect, useState } from "react";

const BasketContext = createContext(null);

export function BasketProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("invictus_basket") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("invictus_basket", JSON.stringify(items));
  }, [items]);

  const add = useCallback((slug, qty = 1, maxQty = 1) =>
    setItems((cur) => {
      const ex = cur.find((i) => i.slug === slug);
      if (ex) return cur.map((i) => (i.slug === slug ? { ...i, qty: Math.min(maxQty, i.qty + qty) } : i));
      return [...cur, { slug, qty: Math.min(maxQty, qty) }];
    }), []);

  const setQty = useCallback((slug, qty, maxQty = 1) =>
    setItems((cur) =>
      qty <= 0 ? cur.filter((i) => i.slug !== slug) : cur.map((i) => (i.slug === slug ? { ...i, qty: Math.min(maxQty, qty) } : i))
    ), []);

  const remove = useCallback((slug) => setItems((cur) => cur.filter((i) => i.slug !== slug)), []);
  const clear = useCallback(() => setItems([]), []);
  const count = items.reduce((s, i) => s + i.qty, 0);

  return (
    <BasketContext.Provider value={{ items, add, setQty, remove, clear, count }}>
      {children}
    </BasketContext.Provider>
  );
}

export const useBasket = () => useContext(BasketContext);
